module.exports = __webpack_public_path__ + "img/cryptosignals-logo-black.c3332542.png";